import React, {useState, useEffect} from 'react';
import {Grid} from "@material-ui/core";
import {Footer, ShoppingSummaryCard, TopNavBar} from '../../components'
import HttpService from "../../services/http.service";
import {getUserDataFromLocalStorage} from "../../services/utils";
import Button from "@material-ui/core/Button";

function Index(props) {

  console.log(props)
  const [order] = useState(props.isOrder || false)
  const [cart, setCart] = useState([]);
  let [total, setTotal] = useState(0);
  let user = getUserDataFromLocalStorage()
  const onSearchClick = (item, category) => {
    props.history.push({
      pathname: '/result',
      state: {search: item, category: category}
    })
  }

  function apiCall(params) {
    HttpService.get(`api/addToCart/list?ssoId=${user.ssoId}`).then(res => {
      if (res) {
        //console.log(res.data)
        setCart(res?.data || [])
        total = res.data.reduce((a, b) => a + b.unitPrice, 0)
        setTotal(total)
        //setLoading(false)
      }
    });
  }

  useEffect(() => {
    apiCall();
  }, []);
  const deleteCart = (id) => {
    console.log(id)
    HttpService.post(`api/addToCart/delete/${id}`).then(res => {
      if (res) {
        console.log(res)
        apiCall();
      }
    });

  }
  const checkoutHandler = () => {
    props.history && props.history.push({pathname: 'checkout', data: cart})
  }
  return (
    <>
      <TopNavBar onClick={onSearchClick}/>
      <Grid container className='shopping-summary-container mt-60'>
        <div className='p-main full-width'>
          <div className='display-flex justify-content-between align-items-center'>
            <h1 className='font-30'>{order ? 'Order History' : 'Shopping Summary'}</h1>
            <Button type="submit" variant="contained" color="primary"
                    onClick={(e) => props.history&&props.history.goBack()}>
              ↶ continue to shopping
            </Button>
          </div>
          {cart.map((item) => <ShoppingSummaryCard item={item} deleteCart={() => deleteCart(item.myCartItemsId)}
                                                   history={props.history} order={order}/>)}
          {order ?
            (<div className='display-flex  flex-column align-items-center checkout-container mt-30'>
              <button className=' add-cart-btn-small pt-15 pb-15'> GO BACK TO PROFILE</button>
            </div>)
            : (cart && cart.length > 0 &&
              <div className='display-flex justify-content-end flex-column align-items-end checkout-container mt-20'>
                <div className='display-flex  align-items-center'>
                  <h1 className='font-22 mr-30'>Total Amount</h1>
                  <h1 className='font-22 ml-20'>PKR {total}</h1>
                </div>
                <button className=' add-cart-btn-small' onClick={checkoutHandler}> CHECK OUT</button>
              </div>)
          }
        </div>
      </Grid>
      <Footer/>
    </>
  );
}

export default Index;
